const version = "0.7.3";

const getVersion = () => {
  return version;
};

export { getVersion };
